export const normalizeCustomerPhone = (value) => {
  let digits = String(value || '').replace(/\D/g, '');
  if (/^0084\d{9}$/.test(digits)) digits = `0${digits.slice(4)}`;
  else if (/^84\d{9}$/.test(digits)) digits = `0${digits.slice(2)}`;
  return /^\d{10,15}$/.test(digits) ? digits : '';
};
export const normalizeCustomerIdentity = (value) => {
  const digits = String(value || '').replace(/[\s.-]/g, '');
  return /^(?:\d{9}|\d{12})$/.test(digits) ? digits : '';
};
export const findCustomerDrafts = (remote, local, currentId, form) => {
  const drafts = new Map(remote.map((draft) => [draft.id, draft]));
  local.forEach((draft) => {
    const saved = drafts.get(draft.id);
    if (!saved || new Date(draft.updatedAt) >= new Date(saved.updated_at)) {
      drafts.set(draft.id, { ...draft, form_data: draft.form, updated_at: draft.updatedAt });
    }
  });
  const phone = normalizeCustomerPhone(form.phone);
  const identity = normalizeCustomerIdentity(form.cccd);
  return [...drafts.values()].filter((draft) => {
    if (draft.id === currentId || draft.completed) return false;
    const customer = draft.form_data || {};
    return Boolean((phone && phone === normalizeCustomerPhone(customer.phone)) || (identity && identity === normalizeCustomerIdentity(customer.cccd)));
  }).sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
};
